const localeMap: Record<string, string> = {
  "en-US": "en",
  "en-UK": "en",
  "de-DE": "de",
  "fr-FR": "fr",
};

export const mapLocaleToContentLanguage = (locale: string): string => {
  return localeMap[locale] || "en";
};
